<template>
  <div class="container">
    <div class="tips-wrap">
      <i class="el-icon-warning"></i>
      以下排课信息中出现的<span class="mwow-red">红色</span>字体说明存在冲突
    </div>
    <div class="part-title">
      <div class="text">
        当前课次<span class="red"
          >（共冲突{{ conflictData.current_num }}次）</span
        >
      </div>
      <span class="toggle-button" @click="currentToggle = !currentToggle">
        {{ currentToggle ? "折叠" : "展开" }}
        <i :class="`el-icon-arrow-${currentToggle ? 'up' : 'down'}`"></i>
      </span>
    </div>
    <div v-show="currentToggle">
      <div class="warning">
        <i class="el-icon-warning"></i> {{ conflictName }}冲突
      </div>
      <div style="max-height: 240px; overflow-y: auto">
        <el-table v-horizontal-scroll size="mini" :data="mainList" stripe>
          <el-table-column label="班级" prop="name">
            <template slot-scope="scope">{{ scope.row.class.name }}</template>
          </el-table-column>
          <el-table-column label="冲突时间" prop="time" width="250px"
            ><template slot-scope="scope">
              {{
                `${scope.row.date}（周${weekDate(
                  scope.row.week_day
                )}）${scope.row.start_time.slice(
                  0,
                  5
                )}-${scope.row.end_time.slice(0, 5)}`
              }}
            </template></el-table-column
          >
          <el-table-column
            label="授课教师"
            prop="teacher"
            v-if="conflictData.teacher_list.length != 0"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.teacher_list.length > 0">
                <span
                  v-for="item in scope.row.teacher_list"
                  :key="item.teacher_id"
                  :class="item.conflict ? 'mwow-red dot' : 'dot'"
                >
                  {{ item.name }}
                </span>
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column
            label="上课教室"
            prop="classroom"
            v-if="conflictData.classroom_list.length != 0"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.classroom"
                :class="scope.row.classroom.conflict ? 'mwow-red dot' : 'dot'"
                >{{ scope.row.classroom.name }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            label="冲突学员"
            prop="student"
            v-if="conflictData.student_list.length != 0"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.student_list.length > 0">
                <span
                  v-for="item in scope.row.student_list"
                  :key="item.student_id"
                  :class="item.conflict ? 'mwow-red' : ''"
                >
                  {{ item.name }}
                </span>
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="part-title">
      <div class="text">
        已有课次<span class="red"
          >（共冲突{{ conflictData.conflict_num }}次）</span
        >
      </div>
      <span class="toggle-button" @click="extraToggle = !extraToggle">
        {{ extraToggle ? "折叠" : "展开" }}
        <i :class="`el-icon-arrow-${extraToggle ? 'up' : 'down'}`"></i>
      </span>
    </div>
    <div v-show="extraToggle">
      <div style="max-height: 240px; overflow-y: auto">
        <el-table v-horizontal-scroll size="mini" :data="extraList" stripe>
          <el-table-column label="班级" prop="name">
            <template slot-scope="scope">{{
              scope.row.class.name ? scope.row.class.name : "-"
            }}</template>
          </el-table-column>
          <el-table-column label="冲突时间" prop="time" width="250px"
            ><template slot-scope="scope">
              {{
                `${scope.row.date}（周${weekDate(
                  scope.row.week_day
                )}）${scope.row.start_time.slice(
                  0,
                  5
                )}-${scope.row.end_time.slice(0, 5)}`
              }}
            </template></el-table-column
          >
          <el-table-column
            label="授课教师"
            prop="teacher"
            v-if="conflictData.teacher_list.length != 0"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.teacher_list.length > 0">
                <span
                  v-for="item in scope.row.teacher_list"
                  :key="item.teacher_id"
                  :class="item.conflict ? 'mwow-red dot' : 'dot'"
                >
                  {{ item.name }}
                </span>
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column
            label="上课教室"
            prop="classroom"
            v-if="conflictData.classroom_list.length != 0"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.classroom"
                :class="scope.row.classroom.conflict ? 'mwow-red dot' : 'dot'"
              >
                {{ scope.row.classroom.name }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            label="冲突学员"
            prop="student"
            v-if="conflictData.student_list.length != 0"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.student_list.length > 0">
                <span
                  v-for="item in scope.row.student_list"
                  :key="item.student_id"
                  :class="item.conflict ? 'mwow-red' : ''"
                >
                  {{ item.name }}
                </span>
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="bottom-wrap">
      <div class="mwow-button-filled mini" @click="handleClose">返回修改</div>
      <div class="mwow-button-filled success mini" @click="handleSubmit">
        忽略冲突继续排课
      </div>
    </div>
  </div>
</template>
<script>
export default {
  // @Prop() conflictData!: any;
  props: ["conflictData"],
  data() {
    return {
      mainList: this.conflictData.current_list || [],
      extraList: this.conflictData.conflict_list || [],
      loading: false,
      conflictInfo: [],
      currentToggle: true,
      extraToggle: true,
      conflictName: "",
    };
  },
  // @Watch("conflictData", { immediate: false, deep: false })
  // onConflictDataChange(n: any) {
  //   this.mainList = n.current_list || [];
  //   this.extraList = n.conflict_list || [];
  //   const name = [];
  //   if (n.teacher_list.length != 0) {
  //     name.push("授课教师");
  //   }
  //   if (n.classroom_list.length != 0) {
  //     name.push("上课教室");
  //   }
  //   if (n.student_list.length != 0) {
  //     name.push("学员");
  //   }
  //   this.conflictName = name.join("、");
  // }
  watch: {
    conflictData: {
      handler(n, o) {
        this.mainList = n.current_list || [];
        this.extraList = n.conflict_list || [];
        const name = [];
        if (n.teacher_list.length != 0) {
          name.push("授课教师");
        }
        if (n.classroom_list.length != 0) {
          name.push("上课教室");
        }
        if (n.student_list.length != 0) {
          name.push("学员");
        }
        this.conflictName = name.join("、");
      },
    },
    immediate: false,
    deep: false,
  },
  mounted() {
    const name = [];
    if (this.conflictData.teacher_list.length != 0) {
      name.push("授课教师");
    }
    if (this.conflictData.classroom_list.length != 0) {
      name.push("上课教室");
    }
    if (this.conflictData.student_list.length != 0) {
      name.push("学员");
    }
    this.conflictName = name.join("、");
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
      this.mainList = [];
      this.extraList = [];
    },
    handleSubmit() {
      if (this.loading) {
        return false;
      }
      this.loading = true;
      this.$emit("submit");
      this.$emit("update:visible", false);
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
    weekDate(w) {
      const week = ["日", "一", "二", "三", "四", "五", "六"];
      return week[w];
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  display: block !important;
}
.tips-wrap {
  background: #fff7e9;
  border-radius: 4px;
  color: #5c5d5e;
  font-size: 12px;
  line-height: 33px;
  padding: 0 10px;
  margin-bottom: 10px;
  i {
    margin-right: 4px;
  }
}
.part-title {
  font-size: 14px;
  color: #5c5d5e;
  font-weight: bold;
  line-height: 34px;
  display: flex;
  .text {
    flex: 1;
    font-size: 12px;
    .red {
      font-size: 12px;
      color: #f56c6c;
    }
  }
  .toggle-button {
    font-size: 12px;
    cursor: pointer;
    i {
      margin-left: 6px;
    }
  }
}
.warning {
  font-size: 12px;
  color: #f56c6c;
  line-height: 32px;
  i {
    color: #5c5d5e;
    margin-right: 4px;
  }
}
.bottom-wrap {
  text-align: right;
  margin-top: 20px;
  .mwow-button-filled {
    margin-left: 12px;
  }
}
.dot {
  &::after {
    content: "、";
  }
  &:last-child {
    &::after {
      display: none;
    }
  }
}
</style>
